// extracted by mini-css-extract-plugin
export default {"main":"n_D","container":"n_F","inner":"n_G","section":"n_Q","sec":"n_5","test":"n_6","belowSection":"n_7"};